import { useOs } from '@wppopen/react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import BriefOverview from 'pages/BriefOverview/BriefOverview'

export function App() {
  /**
   * This hook is provided by the utility package for more convenient work with OS context
   * @return osContext
   * - is a subscribe function that returns you the main context object with MicroAppContext data
   * @return osApi
   * - methods to fire actions on the parent OS level
   *
   * Read more about it in the README file
   */
  const { osContext } = useOs()

  return (
    <BrowserRouter basename={osContext.baseUrl}>
      <Routes>
        <Route path="/" element={<BriefOverview />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}
